import { writable } from 'svelte/store'
import type { Group } from 'three'

type PendingPlacement = {
  groups: Group[]
  type: 'file' | 'printer'
  printerModel?: PrinterModel
  onPlaced: () => Promise<void> | void
}

export const pendingPlacement = writable<PendingPlacement | null>(null)
